import Vue from 'vue'
import store from '@/store'
import { autoscheduleConstants } from '@/constants'

const items = [
  {
    text: 'Отчёты (Альфа-версия)',
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    'icon-prepend': 'dashboard',
    model: false,
    name: 'dashboard',
    subRoutes: ['dashboard'],
    permissions: [Vue.config.permissions.PERMISSIONS_CONSTANTS.DASHBOARD],
    order: 0,
  },
  {
    text: 'Заявки',
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    'icon-prepend': 'calendar_today',
    model: false,
    subRoutes: ['booking'],
    children: [
      { text: 'Список заявок', name: 'bookings', permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.BOOKINGS },
      {
        text: 'Добавить заявку',
        name: 'newBooking',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_BOOKING,
      },
      {
        text: 'Лист ожидания ',
        name: 'waitingList',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.WAITING_LIST,
      },
    ],
    permissions: [
      Vue.config.permissions.PERMISSIONS_CONSTANTS.BOOKINGS,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_BOOKING,
    ],
    order: 1,
  },
  {
    text: 'Сотрудники',
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    'icon-prepend': 'supervised_user_circle',
    model: false,
    subRoutes: ['employer'],
    children: [
      {
        text: 'Список сотрудников',
        name: 'employers',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYEES,
      },
      {
        text: 'Регистрация сотрудников',
        name: 'registration-employers',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYEES,
      },
      {
        text: 'Добавить сотрудника',
        name: 'newEmployer',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_EMPLOYEE,
      },
      {
        text: 'График работы сотрудников',
        name: 'Schedule',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SCHEDULE,
      },
      {
        text: 'Лист прихода/ухода',
        name: 'Attendance',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SCHEDULE,
        // permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.LIST_ACTIVE_FINGERPRINT
      },
      {
        text: 'Фотоработы',
        name: 'Photoworks',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PHOTO_WORK,
      },
      /*
      // TODO: Remove this
      {
        text: 'Лист прихода/ухода OLD',
        name: 'listActiveFingerprint',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.LIST_ACTIVE_FINGERPRINT
      },
       */
    ],
    permissions: [
      Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYEES,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_EMPLOYEE,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.SCHEDULE,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.CANDIDATES,
    ],
    order: 2,
  },
  {
    text: 'Авторасписание',
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    'icon-prepend': 'date_range',
    model: false,
    subRoutes: ['SheduleWishes'],
    children: [
      { text: 'Статистика', name: 'statistics', permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS },
      {
        text: 'Прогнозирование',
        name: 'forecasting',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_ANALYTICS,
      },
      {
        text: 'Страницы мастеров',
        name: 'masterPage',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS_TABLETS,
      },
      // пока что этот раздел скрыт по просьбе Макса
      // { text: 'События', name: 'events', permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS_TABLETS },
      {
        text: 'Настройки мастеров',
        name: 'mastersTable',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS_TABLETS,
      },
    ],
    permissions: 'superUserPlusFocus',
    order: 3,
  },
  {
    text: 'Клиенты',
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    'icon-prepend': 'supervisor_account',
    model: false,
    subRoutes: ['customer'],
    children: [
      {
        text: 'Список клиентов',
        name: 'customers',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CUSTOMERS,
      },
      {
        text: 'Добавить клиента',
        name: 'newCustomer',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_CUSTOMER,
      },
      {
        text: 'Отзывы',
        name: 'reviewsMain',
        permission: [
          Vue.config.permissions.PERMISSIONS_CONSTANTS.APP_REVIEW_LIST,
          Vue.config.permissions.PERMISSIONS_CONSTANTS.FEEDBACKS_LIST,
        ],
      },
      {
        text: 'Переделки',
        name: 'alterations',
        permission: [
          Vue.config.permissions.PERMISSIONS_CONSTANTS.CLAIM.view,
          Vue.config.permissions.PERMISSIONS_CONSTANTS.DISCOUNT_VIEW,
        ],
      },
      {
        text: 'Новый мастер',
        name: 'newEmployers',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYER_NEW_MASTER_VIEW,
      },
      // {
      //   text: 'Управление сегментами',
      //   name: 'customersSegments',
      //   permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SEGMENT.view,
      // },
      {
        text: 'Акции',
        name: 'promotions',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PROMOTION_VIEW,
      },
      {
        text: 'Клубные карты',
        name: 'club-card-types',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CLUB_CARD_TYPES.view,
      },
    ],
    permissions: [
      Vue.config.permissions.PERMISSIONS_CONSTANTS.CUSTOMERS,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_CUSTOMER,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.FEEDBACKS_LIST,
    ],
    order: 4,
  },
  {
    text: 'Товары',
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    'icon-prepend': 'shopping_cart',
    model: false,
    subRoutes: [
      'good',
      'goodGroups',
      'goodGroupsView',
      'goodFlowView',
      'goodGiveView',
      'goodInvoiceView',
      'goodInventView',
      'goodOrderView',
      'goodOrderRuleView',
    ],
    children: [
      {
        text: 'Движение товаров',
        name: 'goodFlows',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_FLOW,
      },
      {
        text: 'Остатки товаров',
        name: 'goodRemains',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_REMAINS,
      },
      {
        text: 'Выдача материалов',
        name: 'goodGives',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_USAGE,
      },
      {
        text: 'Список товаров',
        name: 'goods',
        permission: [
          Vue.config.permissions.PERMISSIONS_CONSTANTS.GOODS,
          Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_GROUPS,
        ],
      },
      {
        text: 'Импорт товарных накладных',
        name: 'goodInvoices',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_INVOICES,
      },
      {
        text: 'Инвентаризация товаров',
        name: 'goodInvents',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_INVENTS,
      },
      {
        text: 'Автозаказ',
        name: 'goodOrders',
        permission: [
          Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_ORDERS,
          Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_ORDER_RULES,
        ],
      },
    ],
    permissions: [
      Vue.config.permissions.PERMISSIONS_CONSTANTS.GOODS,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_GROUPS,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_FLOW,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_REMAINS,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_USAGE,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_INVOICES,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_INVENTS,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_ORDERS,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_ORDER_RULES,
    ],
    order: 5,
  },
  {
    text: 'Оборудование',
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    'icon-prepend': 'construction',
    model: false,
    subRoutes: ['equipmentTypeView'],
    children: [
      {
        text: 'Типы оборудования',
        name: 'equipmentTypes',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EQUIPMENT_TYPES,
      },
    ],
    permissions: [Vue.config.permissions.PERMISSIONS_CONSTANTS.EQUIPMENT_TYPES],
    order: 5,
  },
  {
    text: 'Финансы',
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    'icon-prepend': 'attach_money',
    model: false,
    subRoutes: [
      'finance-pko-view',
      'finance-rko-view',
      'finance-order-new',
      'finance-order-new-by-booking',
      'finance-order-view',
    ],
    children: [
      {
        text: 'Оказание услуг',
        name: 'finance-order',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.OU,
      },
      {
        text: 'Запросы на выплату',
        name: 'finance-payment-requests',
        permission: '', // Vue.config.permissions.PERMISSIONS_CONSTANTS.RKO,
      },
      {
        text: 'Расходный кассовый ордер',
        name: 'finance-rko',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.RKO,
      },
      {
        text: 'Размен',
        name: 'exchange',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EXCHANGE_VIEW,
      },
      {
        text: 'Зарплаты',
        name: 'finance-zp',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SALARY,
      },
      {
        text: 'Сертификаты',
        name: 'certificate',
        permission: [
          Vue.config.permissions.PERMISSIONS_CONSTANTS.CERTIFICATE,
          Vue.config.permissions.PERMISSIONS_CONSTANTS.CERTIFICATE_RECONCILIATION_VIEW,
        ],
      },
      {
        text: 'Инвентаризация сертификатов',
        name: 'certificates-invent',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CERTIFICATE_VIEW,
      },
      {
        text: 'Планы',
        name: 'unitRevenuePlans',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.REVENUE_PLANS.view,
      },
      {
        text: 'Промокоды',
        name: 'vouchers',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.VOUCHER.view,
      },
      {
        text: 'Сегменты',
        name: 'segments',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SEGMENT.view,
      },
      {
        text: 'Бонусы',
        name: 'bonus-system',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.BONUSES.view,
      },
      {
        text: 'Клубные карты',
        name: 'club-cards',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CLUB_CARDS.view,
      },
      {
        text: 'Выдача сертификатов',
        name: 'certificates-logs',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CERTIFICATE_LOGS.view,
      },
    ],
    permissions: [
      Vue.config.permissions.PERMISSIONS_CONSTANTS.RKO,
      // Vue.config.permissions.PERMISSIONS_CONSTANTS.PKO,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.OU,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.ZP,
    ],
    order: 6,
  },
  // //////////////
  {
    text: 'Аналитика',
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    'icon-prepend': 'insert_chart',
    model: false,
    subRoutes: ['analyticsView'],
    children: [
      { text: 'Мои отчёты', name: 'analytics', permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS },
      {
        text: 'Аналитика по планшетам',
        name: 'analytics-tablets',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS,
      },
      {
        text: 'Добавить отчёт',
        name: 'analyticsViewNew',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_ANALYTICS,
      },
      {
        text: 'Заполняемость студий',
        name: 'analyticsFillStudios',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS,
      },
    ],
    permissions: [
      Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_ANALYTICS,
    ],
    order: 7,
  },
  {
    text: 'Уведомления',
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    'icon-prepend': 'info_outline',
    name: 'notify-log',
    permissions: [Vue.config.permissions.PERMISSIONS_CONSTANTS.NOTIFY, 'superUser'],
    order: 8,
    children: [
      {
        text: 'История уведомлений',
        name: 'notify-log',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NOTIFY,
      },
      {
        text: 'Отправить уведомление',
        name: 'notify-send',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NOTIFY,
      },
      {
        text: 'Шаблоны уведомлений',
        name: 'notify-templates',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NOTIFY,
      },
      {
        text: 'Опросники',
        name: 'surveys',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SURVEY.view,
      },
    ],
  },
  {
    text: 'Сайт',
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    'icon-prepend': 'app_settings_alt',
    name: 'client-app',
    permissions: [Vue.config.permissions.PERMISSIONS_CONSTANTS.NOTIFY, 'superUser'],
    order: 9,
    children: [
      // {
      //   text: 'Рекламные баннеры',
      //   name: 'client-app_banners',
      //   permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NOTIFY,
      // },
      {
        text: 'Рекламные баннеры',
        name: 'site-banners',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NAIL_DESIGNS,
      },
      {
        text: 'Дизайны ногтей',
        name: 'client-app_nail-designs',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NAIL_DESIGNS,
      },
      {
        text: 'Новости',
        name: 'client-app_news',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NAIL_DESIGNS,
      },
      {
        text: 'Обучение',
        name: 'master-app_teach',
        // permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NAIL_DESIGNS,
      },
      {
        text: 'Конкурсы',
        name: 'master-contest',
        // permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NAIL_DESIGNS,
      },
      {
        text: 'Колесо',
        name: 'bonus-wheel',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NAIL_DESIGNS,
      },
      {
        text: 'Конкурсы',
        name: 'master-contest',
        // permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NAIL_DESIGNS,
      },
      // {
      //   text: 'Обучение',
      //   name: 'master-app_teach',
      //   // permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NAIL_DESIGNS,
      // },
      // {
      //   text: 'Конкурсы',
      //   name: 'master-contest',
      //   // permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NAIL_DESIGNS,
      // },
    ],
  },
  // {
  //   text: 'Сайт',
  //   icon: 'keyboard_arrow_up',
  //   'icon-alt': 'keyboard_arrow_down',
  //   'icon-prepend': 'settings_input_component',
  //   name: 'client-app',
  //   permissions: [Vue.config.permissions.PERMISSIONS_CONSTANTS.NOTIFY, 'superUser'],
  //   order: 9,
  //   children: [
  //     {
  //       text: 'Рекламные баннеры',
  //       name: 'site-banners',
  //     },
  //   ],
  // },
  // {
  //   text: 'Услуги',
  //   icon: 'keyboard_arrow_up',
  //   'icon-alt': 'keyboard_arrow_down',
  //   'icon-prepend': 'assignment',
  //   model: false,
  //   subRoutes: [
  //     'serviceCategory',
  //     'serviceView'
  //   ],
  //   children: [
  //     { text: 'Список услуг',
  //       name: 'services',
  //       permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SERVICES
  //     },
  //     // {
  //     //   text: 'Добавить услугу',
  //     //   name: 'serviceNew',
  //     //   permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_SERVICES
  //     // },
  //     // {
  //     //   text: 'Добавить категорию услуг',
  //     //   name: 'serviceCategoryNew',
  //     //   permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_SERVICE_CATEGORY
  //     // },
  //     {
  //       text: 'Шаблоны услуг',
  //       name: 'serviceTemplates',
  //       permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SERVICE_TEMPLATES
  //     }
  //   ],
  //   permissions: [
  //     Vue.config.permissions.PERMISSIONS_CONSTANTS.SERVICES,
  //     Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_SERVICES,
  //     Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_SERVICE_CATEGORY,
  //     Vue.config.permissions.PERMISSIONS_CONSTANTS.SERVICE_TEMPLATES,
  //   ],
  //   order: 9
  // },
  {
    text: 'Настройки',
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    'icon-prepend': 'settings',
    model: false,
    subRoutes: [],
    children: [
      {
        text: 'Должности и права доступа',
        name: 'positionAndAccess',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.WORK_POSITIONS_VIEW,
      },
      {
        text: 'Настройки аккаунта',
        name: 'settingsAccount',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
      },
      {
        text: 'Компании и бренды',
        name: 'companies',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.COMPANY_VIEW,
      },
      {
        text: 'Список подразделений',
        name: 'units',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.UNITS_VIEW,
      },
      // {
      //   text: 'Настройки компании',
      //   name: 'settingsCompany',
      //   params: { id: '0' },
      //   permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.COMPANY_SETTINGS
      // },
      {
        text: 'Справочник контрагентов',
        name: 'contractors',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CONTRACTORS,
      },
      {
        text: 'Настройки локаций',
        name: 'SettingsLocation',
        permissions: 'superUser',
      },
      {
        text: 'Изменения системы',
        name: 'logs',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.LOGS,
      },
      {
        text: 'Настройки виджета',
        name: 'widget-settings',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.LOGS,
      },
      { text: 'Услуги', name: 'services', permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SERVICES },
      { text: 'Партнеры', name: 'partners', permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PARTNERS_VIEW },
      {
        text: 'Телефония',
        name: 'call-center-workplace',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CALL_CENTER_WORKPLACE.view,
      },
    ],
    permissions: [
      // Vue.config.permissions.PERMISSIONS_CONSTANTS.COMPANY_SETTINGS,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.CONTRACTORS,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.UNITS_VIEW,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.LOGS,
    ],
    order: 10,
  },
  // {
  //   text: 'Должности',
  //   icon: 'keyboard_arrow_up',
  //   'icon-alt': 'keyboard_arrow_down',
  //   'icon-prepend': 'card_travel',
  //   model: false,
  //   subRoutes: [
  //     'workPositionView'
  //   ],
  //   children: [
  //     {
  //       text: 'Должности и права доступа',
  //       name: 'positionAndAccess',
  //       permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.WORK_POSITIONS_VIEW
  //     },
  //     {
  //       text: 'Новая должность',
  //       name: 'workPositionNew',
  //       permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.WORK_POSITIONS_UPDATE
  //     }
  //   ],
  //   permissions: [
  //     Vue.config.permissions.PERMISSIONS_CONSTANTS.WORK_POSITIONS_VIEW,
  //     Vue.config.permissions.PERMISSIONS_CONSTANTS.WORK_POSITIONS_UPDATE,
  //   ],
  //   // TODO Раздел будет удален, пока ставим послендим
  //   order: 11
  // },
  {
    text: ' Центр связи',
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    'icon-prepend': 'email_outline',
    model: false,
    children: [
      {
        text: 'Все обращения',
        name: 'tickets',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.TICKETS.view,
      },
      // {
      //   text: 'Ожидают согласования',
      //   name: 'unapprovedTickets',
      //   permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.TICKETS.view,
      // },
      {
        text: 'Добавить обращение',
        name: 'ticketsNew',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.TICKETS.create,
      },
      {
        text: 'Группы пользователей',
        name: 'ticketsGroups',
      },
      {
        text: 'Список уведомлений',
        name: 'notification',
        showAll: true,
      },
      {
        text: 'Добавить новость',
        name: 'addNotification',
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NOTIFICATIONS_NEWS_CREATE,
      },
    ],
    permissions: [
      Vue.config.permissions.PERMISSIONS_CONSTANTS.TICKETS.view,
      Vue.config.permissions.PERMISSIONS_CONSTANTS.TICKETS.create,
    ],
    order: 12,
  },
]
async function createPermissionItems(resolve, reject) {
  const user = store.getters.user
  const isFromFocus = autoscheduleConstants.workPositionsIdsForAutoschedule.some(item => item === user.work_position_id)
  const permissions = store.getters.userSelfPermissions
  let result = items

  if (!isFromFocus && !user.is_superuser) {
    const filteredItems = _.filter(items, item => {
      return _.intersection(permissions, item.permissions).length >= 1
    })

    result = _.map(filteredItems, item => {
      item.children = _.filter(item.children, child => {
        if (Array.isArray(child.permission)) {
          let result = false
          child.permission.forEach(el => {
            if (permissions.some(e => e === el)) {
              result = true
            }
            return result
          })
          return result
        } else {
          return _.includes(permissions, child.permission) || child.showAll
        }
      })
      return item
    })
  }

  return resolve(_.sortBy(result, item => item.order))
}

export const sidebarItems = () => {
  return new Promise((resolve, reject) => {
    const user = store.getters.user
    if (user === null) {
      resolve([])
    }

    if (store.getters.userSelfPermissions.length) return createPermissionItems(resolve, reject)

    store
      .dispatch('GET_EMPLOYER_PERMISSIONS', {
        employerId: user.id,
        full: 1,
      })
      .then(() => {
        return createPermissionItems(resolve, reject)
      })
      .catch(() => {
        resolve([])
      })
  })
}
